import { getCartAcsCountByProduct, getCartServicesCountByProduct, TCartItem } from '@/entities/cart'

import { getCorrectAcsName, getCorrectServiceName } from './string/getCorrectName'

/**
 * Method for getting a string with brief
 * information about the list of active accessories and services
 *
 * @param relatedItems - list of active accessories and services
 * @param id - id of parent product
 *
 * */
export const getTotalSetText = (relatedItems: TCartItem[], id: number): string => {
	const servicesCount: number = getCartServicesCountByProduct(relatedItems, id)
	const acsCount: number = getCartAcsCountByProduct(relatedItems, id)

	const correctServiceName = getCorrectServiceName(servicesCount)
	const correctAcsName = getCorrectAcsName(acsCount)
	const serviceString = `${servicesCount ? `${servicesCount} ${correctServiceName}` : ``}`
	const acsString = `${acsCount ? `${acsCount} ${correctAcsName}` : ``}`

	return `+ ${serviceString} ${servicesCount && acsCount ? `, ` : ``}${acsString}`
}
